<script lang="ts" setup>

  type Props = {
    illustration: string
    titleTop?: string
    titleMain?: string
    titleBottom?: string
    bubbleTitle?: string
    bubbleText?: string
  }

  const props = defineProps<Props>()
  const { matches: matchDesktop } = useMatchMedia(ScreenWidth.desktop)
</script>

<template>
  <div
    class="c-static-page-header"
    :class="{ 'match-desktop': matchDesktop }"
  >
    <div class="header">
      <div class="title">
        <span
          v-if="props.titleTop"
          class="top"
          v-html="props.titleTop"
        />
        <h1
          class="main"
          v-html="props.titleMain"
        />
        <p
          class="bottom"
          v-html="props.titleBottom"
        />
      </div>
      <p class="illustration">
        <img
          alt="illustration"
          :src="props.illustration"
        >
      </p>
      <div class="bubble">
        <p
          class="bubble-title"
          v-html="props.bubbleTitle"
        />
        <p
          class="bubble-text"
          v-html="props.bubbleText"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>

.c-static-page-header {
  background-color: white;

  .header {
    .title {
      padding: 1.5rem;

      .top {
        display: inline;
        padding: 0.125rem 0.25rem;
        margin-top: 1.875rem;
        background-color: var(--color-secondary);
        color: white;
        font-family: Open-Sans, sans-serif;
        font-size: 1em;
        font-weight: 600;
        line-height: 1.5;

        &:deep(strong) {
          padding: 0 0.25rem;
          font-weight: 700;
        }
      }

      .main {
        margin-top: 1.25em;
        color: var(--color-secondary);
        font-family: Bariol, sans-serif;
        font-size: 2em;
        font-weight: 700;

      }

      .bottom {
        color: var(--color-secondary);
        font-family: Open-Sans, sans-serif;
        font-size: 1.25em;
        font-weight: 600;

      }
    }

    .bubble {
      position: relative;
      padding: 1.25rem 1rem;
      border-radius: 0.5rem;
      margin: 1.5rem 0.625rem;
      background-color: var(--color-primary);
      line-height: 1.33;

      .bubble-title {
        color: var(--color-secondary);
        font-family: Open-Sans, sans-serif;
        font-size: 1em;
        font-weight: 600;
      }

      .bubble-text {
        margin-top: 1.5em;
        color: var(--color-secondary);
        font-family: Open-Sans, sans-serif;
        font-size: 1em;
        font-weight: 400;
      }

      &::after {
        position: absolute;
        right: 2rem;
        bottom: 100%;
        display: flex;
        width: 0;
        height: 0;
        border-right: 1.25rem solid transparent;
        border-bottom: 1rem solid var(--color-primary);
        border-left: 1.25rem solid transparent;
        content: "";
      }
    }

    .illustration {
      display: flex;
      width: 100%;
      height: 22rem;
      justify-content: flex-end;
      overflow-x: hidden;

      img {
        position: relative;
        right: 0;
        display: flex;
        width: auto;
        height: 100%;
      }
    }
  }

  @media screen and (width >= 1024px) {
    .header {
      position: relative;
      display: flex;
      height: 50rem;
      flex-direction: column;
      padding-left: 10rem;
      margin-top: 5em;

      .title {
        z-index: 1;
        width: 45em;
        padding: 3rem 0;

        .top {
          font-size: 1.5em;
        }

        .main {
          font-size: 4em;

        }

        .bottom {
          margin-top: 1em;
          font-size: 2em;
        }
      }

      .illustration {
        position: absolute;
        right: 0;
        bottom: 0;
        display: flex;
        overflow: visible;
        width: 55vw;
        height: auto;

        img {
          object-fit: cover;
        }
      }

      .bubble {
        width: 20em;
        margin-top: 2em;
      }
    }
  }
}
</style>
